export const MARKET_PANEL_VIEW_EVENT = 'viewed-market-panel'
